import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import DataGridClickedPopup from '../../../component/common/popup/DataGridClickedPopup.jsx';

const BdTongJunSungHyunHwang = () => {

    const today = new Date();
    const currentYear = today.getFullYear();

    const [searchParams, setSearchParams] = useState({
        searchGrdc: '',
        searchLoca: '',
        searchYear: currentYear,
        searchGubun: 'PTMI',
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value,
        };
        setSearchParams(newParams);
    };

    const dataHead = ['의료기관명', '종별', '전송일자', '전송시간', '전송횟수'];
    const dataColumn = ['DNAME', 'EMCTYPE', 'TT1', 'TT3', 'TT4'];
    const apiCall = '/ptmiapi/nedis/tonggyeweb/bdtongjunsunghyunhwang_search.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "데이터전송현황";
    const excelHead = [];
    const mergeConfig = [{ key: 'DNAME', row: null }, { key: 'EMCTYPE' }];
    const colWidth = ['30%'];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: colWidth
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const popupPropsInfo = {
        checked: ["TT3"],
        localStorageName: 'junsong',
        popupAddress: "/nedis/currentTrans/junsongDetail_popup.do",
    }

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="8%" />
                        <col width="15%" />
                        <col width="8%" />
                        <col width="15%" />
                        <col width="8%" />
                        <col width="30%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>전송일자</th>
                            <td colSpan='3'>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>전송구분</th>
                            <td>
                                <div className='flex gap-3'>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="PTMI"
                                            checked={searchParams.searchGubun === 'PTMI'}
                                            onChange={handleInputChange}
                                        />
                                        환자정보
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="DGOT"
                                            checked={searchParams.searchGubun === 'DGOT'}
                                            onChange={handleInputChange}
                                        />
                                        퇴실진단
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="DGDC"
                                            checked={searchParams.searchGubun === 'DGDC'}
                                            onChange={handleInputChange}
                                        />
                                        퇴원진단
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="OPPT"
                                            checked={searchParams.searchGubun === 'OPPT'}
                                            onChange={handleInputChange}
                                        />
                                        입원후처치
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <DataGridClickedPopup
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                searchParams={searchParams}
                popupPropsInfo={popupPropsInfo}
                mergeConfig={mergeConfig}
                flag={true}
            />
        </Main>
    )
}

export default BdTongJunSungHyunHwang;